
import Vue from 'vue'
import SectionPanel from '@/pages/categories/components/SectionPanel.vue'
import { displayItemsCount } from '@/pages/categories/const'
import { ProductType } from '@/types'

interface Data {
  visibleItemsCount: number
}

export default Vue.extend({
  components: {
    SectionPanel
  },
  props: {
    products: {
      type: Array as () => ProductType[],
      required: true
    }
  },
  data(): Data {
    return {
      visibleItemsCount: 0
    }
  },
  computed: {
    isTabletOrBelow(): boolean {
      return window.innerWidth <= 1024
    },
    displayShowMoreBtn(): boolean {
      return this.hiddenItemsCount > 0
    },
    visibleItemsList(): ProductType[] {
      return this.products.filter((group, index) => {
        return index < this.visibleItemsCount
      })
    },
    hiddenItemsCount(): number {
      return this.products.length - this.visibleItemsCount
    }
  },
  mounted(): void {
    if (this.isTabletOrBelow) {
      this.visibleItemsCount = displayItemsCount.tabletAndBelow
    } else {
      this.visibleItemsCount = displayItemsCount.desktop
    }
  },
  methods: {
    productURL(productId: number): string {
      return productId ? `/products/${productId}` : ''
    },
    showMoreItems(): void {
      if (this.isTabletOrBelow) {
        this.visibleItemsCount += displayItemsCount.tabletAndBelow
      } else {
        this.visibleItemsCount += displayItemsCount.desktop
      }
    }
  }
})
